import { Heart, ShieldCheck, Users, Sparkles, Lock } from "lucide-react";
import SEO from "@/components/SEO";

export default function ChiSiamo() {
  return (
    <div data-testid="chi-siamo-page" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <SEO
        path="/chi-siamo"
        title="Chi siamo — Il servizio gratuito contro le truffe agli anziani"
        description="ScudoNonni è un servizio italiano gratuito che aiuta gli anziani a riconoscere e prevenire le truffe online: SMS, WhatsApp, email e phishing. La nostra missione e i nostri valori."
      />
      <div className="text-center mb-12 animate-fade-up">
        <Heart size={64} className="mx-auto text-[#22C55E] mb-6" />
        <h1 className="font-heading text-4xl md:text-6xl font-extrabold text-[#1E3A8A] leading-tight">
          Chi siamo
        </h1>
        <p className="mt-5 text-xl md:text-2xl text-gray-700 leading-relaxed">
          ScudoNonni è un servizio italiano gratuito, pensato per proteggere i nonni dalle truffe online.
        </p>
      </div>

      <div className="bg-white rounded-[2rem] shadow-lg border-4 border-blue-50 p-8 md:p-12 mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#1E3A8A] mb-4">
          La nostra missione
        </h2>
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-4">
          Ogni anno migliaia di persone anziane in Italia perdono risparmi e
          serenità a causa di truffe via SMS, email, WhatsApp e telefono. Noi
          vogliamo aiutare i nonni a riconoscere queste truffe prima che sia
          troppo tardi.
        </p>
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
          Abbiamo creato uno strumento semplice: incolla il testo o carica una
          foto di un messaggio sospetto, e in pochi secondi ti diciamo se è
          autentico o pericoloso, con consigli chiari su cosa fare.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
        {[
          { icon: ShieldCheck, title: "Gratuito", desc: "Sempre, per tutti i nonni d'Italia." },
          { icon: Lock, title: "Privato", desc: "Non chiediamo nome né email." },
          { icon: Sparkles, title: "Intelligente", desc: "Usiamo l'intelligenza artificiale più recente." },
        ].map((c, i) => (
          <div
            key={c.title}
            data-testid={`valore-${i}`}
            className="bg-white p-6 rounded-3xl shadow-lg border-2 border-gray-100 text-center"
          >
            <div className="w-16 h-16 mx-auto rounded-2xl bg-[#DBEAFE] flex items-center justify-center text-[#1E3A8A] mb-4">
              <c.icon size={32} />
            </div>
            <h3 className="font-heading text-xl font-bold text-[#1E3A8A] mb-2">
              {c.title}
            </h3>
            <p className="text-lg text-gray-700">{c.desc}</p>
          </div>
        ))}
      </div>

      <div className="bg-[#DCFCE7] border-4 border-[#22C55E] rounded-[2rem] p-8 md:p-12 text-center">
        <Users size={56} className="mx-auto text-[#16A34A] mb-4" />
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#14532D] mb-4">
          Aiutaci a proteggere altri nonni
        </h2>
        <p className="text-lg md:text-xl text-[#14532D] leading-relaxed">
          Parlane in famiglia, condividi ScudoNonni con i tuoi cari. Ogni nonno
          informato è una truffa in meno.
        </p>
      </div>
    </div>
  );
}
